// extracted by mini-css-extract-plugin
export default {"root":"VoteDetail_root__l3ivc","body":"VoteDetail_body__ToHmv"};